module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_9005.07441a20.png";